import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=6be03386&"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be03386')) {
      api.createRecord('6be03386', component.options)
    } else {
      api.reload('6be03386', component.options)
    }
    module.hot.accept("./VerticalNavMenuItems.vue?vue&type=template&id=6be03386&", function () {
      api.rerender('6be03386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItems.vue"
export default component.exports